import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Commodity } from "@assets/types";
import CommodityService from "@services/CommodityService";
import { RootState } from "@state/store";

export const getAllCommodities = createAsyncThunk(
  "commodity/getAllCommodities",
  () => CommodityService.getAllCommodities()
);

export const getMachineryCommodities = createAsyncThunk(
  "commodity/getMachineryCommodities",
  () => CommodityService.getMachineryCommodities()
);

export interface CommoditiesState {
  commodities: Commodity[];
  machineryCommodities: Commodity[];
}

export const initialCommoditiesState: CommoditiesState = {
  commodities: [],
  machineryCommodities: [],
};

export const commoditiesSlice = createSlice({
  name: "commodities",
  initialState: initialCommoditiesState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCommodities.rejected, (state) => {
        state.commodities = [];
      })
      .addCase(
        getAllCommodities.fulfilled,
        (state, action: PayloadAction<Commodity[]>) => {
          state.commodities = action.payload;
        }
      )
      .addCase(getMachineryCommodities.rejected, (state) => {
        state.machineryCommodities = [];
      })
      .addCase(
        getMachineryCommodities.fulfilled,
        (state, action: PayloadAction<Commodity[]>) => {
          state.machineryCommodities = action.payload;
        }
      );
  },
});

export const commoditiesState = (state: RootState) =>
  state.commoditiesSlice.commodities;
export const machineryCommoditiesState = (state: RootState) =>
  state.commoditiesSlice.machineryCommodities;

export default commoditiesSlice.reducer;
